<template>
  <div 
    v-if="$_productHasTagNews()"
    :class="{'single-product-list__has-tags--reverse' : $_productHasTagNews()}"
    class="single-product-list__has-tags">
    <strong
      v-if="$_productHasTagNews()"
      class="single-product-list__has-tags__news">
        Novità
    </strong>
  </div>
</template>

<script>

export default {
  name: 'SingleProductListHasTags',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    $_productHasTagNews () {
      if (typeof this.product.fields.tags === 'undefined') return false
      return this.product.fields.tags.some(tag => tag.sys.id === '1EiZKOpvDNKhXd2z0xHWJd')
    }
  }
}
</script>

<style lang="scss">
  @import "./singleProductListHasTags.scss";
</style>
